import Instance from "./instance";

const deployApp = (_request, _data) => {
    return _request.fetch({
        method: "POST",
        endpoint: `apps/deploy`,
        params: _data
    });
};

class App {
    constructor(_appId, _request) {
        this.request = _request;
        this.appId = _appId;
    }

    async deploy(_data, redirect = false) {
        try {
            _data.app = this.appId;
            if (this.users && this.users.length > 0) {
                let res = await deployApp(this.request, _data);
                let retData = res;
                let instance = new Instance(res.data, this.request);
                res = await instance.assign_workers(this.users, this.delay);
                retData.message = `App was deployed successfully and ${res.message}`;
                return retData;
            } else {
                return deployApp(this.request, _data);
            }
        } catch (_err) {
            if (_err.message) throw new Error(_err.message);
            else throw Error(_err);
        }
    }

    workers(_workers, _delay = null) {
        this.users = _workers;
        this.delay = _delay
        return this;
    }

    get() {
        return this.request.fetch({
            method: "GET",
            endpoint: "app",
            params: [this.appId]
        });
    }

    update(_json) {
        return this.request.fetch({
            method: "PUT",
            endpoint: `app/${this.appId}/update`,
            params: _json
        });
    }

}

export default App;
